import { render, staticRenderFns } from "./ModelInfo.vue?vue&type=template&id=43fce95a"
import script from "./ModelInfo.vue?vue&type=script&lang=ts"
export * from "./ModelInfo.vue?vue&type=script&lang=ts"
import style0 from "./ModelInfo.vue?vue&type=style&index=0&id=43fce95a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports